import { render } from "./EmployeePayrollPayslips.vue?vue&type=template&id=7212e8ac&scoped=true"
import script from "./EmployeePayrollPayslips.vue?vue&type=script&lang=js"
export * from "./EmployeePayrollPayslips.vue?vue&type=script&lang=js"

import "./EmployeePayrollPayslips.vue?vue&type=style&index=0&id=7212e8ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7212e8ac"]])

export default __exports__